import { Box } from '@mui/material';
import { UserManagement } from '@/components/UserManagement';
import { DefaultLayout } from '@/layouts';
import { Can } from '@/components/Can';
import { PageLoader } from '@/components/shared/PageLoader';
import UnauthorizedAccess from '@/components/UnauthorizedAccess';
import useAbility from '@/hooks/useAbility';

export const UserManagementPage = () => {
  const { loading } = useAbility();
  if (loading) {
    return (
      <DefaultLayout variant="inspection">
        <Box sx={{ position: 'relative', top: '25rem' }}>
          <PageLoader />
        </Box>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout variant="inspection">
      <Can I="manage" a="User" passThrough>
        {(allowed: unknown) => (allowed ? <UserManagement /> : <UnauthorizedAccess />)}
      </Can>
      <UserManagement />
    </DefaultLayout>
  );
};
